"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Progress.default;
  }
});

var _Progress = _interopRequireDefault(require("./Progress"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }